const Styles = {
    headerContainer: {
        backgroundColor: '#000000'
    },
    headerImg: {
        height: '50px',
        marginTop: '20px',
        objectFit: 'contain',
        marginBottom: '20px',
    },
    heading: {
        textAlign: 'center',
        fontSize: '20px',
        marginTop: '20px',
        fontWeight: 900
    },
    sectionTitle: {
        marginTop: '20px',
        marginBottom: '10px',
        fontSize: '18px'
    },
    field: {
        display: 'flex',
        flexDirection: 'row',
        fontSize: '14px',
        marginTop: '5px',
        marginBottom: '5px',
    },
    body: {
        marginLeft: '40px',
        marginRight: '40px'
    },
    textContainer: {
        display: 'flex',
        flexDirection: 'column',
        fontSize: '14px',
        marginTop: '5px',
        marginBottom: '5px',
        lineHeight: '1.5px'
    },
    label: {
        color: '#1B3C8B'
    }
};

export default Styles;